module.exports = __webpack_public_path__ + "img/base_divers_specialite.668c5f7e.svg";